<template>
  <i
    class="tm-empty-view"
    :class="{
      '-and-lightbox': !disableLightboxFeature && $props.lightboxIsEmpty,
    }"
  >
    <i v-if="$props.lightboxIsEmpty || disableLightboxFeature" class="-border">
      <i class="-big wt2-text-2xl">Your timeline is empty...</i>
      <i class="-small wt2-text-m">Drag media here to create your timeline</i>
      <div class="-ai-separator" v-if="hasAiFeatures">- OR -</div>
      <div class="tm-empty-view-ai-btn-container" v-if="hasAiFeatures">
        <wt-button
          class="-ai-button"
          :icon="'wticon-magic-wand'"
          :text="'Build with AI'"
          @click="clickCreateAiStory"
          v-tooltip.extend="tooltipOptions"
          :disabled="hasUploadingAssets"
        />
      </div>
    </i>
    <tm-row-empty v-else />
  </i>
</template>

<script>
import tmRowEmpty from './grid/tmRowEmpty.vue';
import wtMakeNewWochit from 'components/modals/types/wtMakeNewWochit.component.vue';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      disableLightboxFeature: true,
    };
  },
  name: 'tm-empty-view',
  components: {
    tmRowEmpty,
  },

  props: {
    lightboxIsEmpty: { type: Boolean, required: true },
  },

  watch: {},

  computed: {
    ...mapGetters([
      'lightboxAssetUUIDs',
      'hasUploadingAssets',
      'hasImageVideoAssets',
      'hasVoiceOverAssets',
    ]),

    hasAiFeatures() {
      return (
        tk.context.organization.premiumFeatures &&
        tk.context.organization.premiumFeatures.includes('AI_PROMPT')
      );
    },

    toolTipTitle() {
      return 'Please wait for all uploads to finish';
    },

    tooltipOptions() {
      return {
        title: this.toolTipTitle,
        trigger: 'hover',
        placement: 'bottom',
        delay: 100,
        wrapperClass: '-ai-tooltip',
        container: '.tm-empty-view-ai-btn-container',
      };
    },
  },

  methods: {
    clickCreateAiStory() {
      app.showModal({
        type: 'custom scrollable',
        component: wtMakeNewWochit,
        componentPropsData: {
          existingStoryParams: {
            storyId: this.$store.state.story.id,
            programmerId: this.$store.state.story.programmerId,
            brandId: this.$store.state.story.brandId,
            themeId: this.$store.state.story.themeInfo.themeId,
            assetUUIDs: this.lightboxAssetUUIDs.imageVideoUUIDs || [],
            hasOtherAssetsInLightbox: this.lightboxAssetUUIDs.hasOtherAssets,
            aspectRatio: this.$store.state.story.themeInfo.aspectRatio,
            hasVoiceOverAssets: this.hasVoiceOverAssets,
            emptyTimeline: true,
          },
        },
      });
    },
  },
};
</script>

<style lang="scss">
.tm-timemachine > .tm-empty-view {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  color: rgba(0, 0, 0, 0.5);
  background-color: #f2f2f2;
  padding: var(--tm-pxAxisTopPadding) var(--tm-pxAxisSidePadding) 45px
    var(--tm-pxAxisSidePadding);

  &.-and-lightbox {
    padding: 22px;
  }

  > .-border {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    border: 2px dashed rgba(0, 0, 0, 0.3);
    border-radius: 2px;

    > .-big {
      color: $color-normal;
    }
    > .-small {
      font-style: italic;
      color: $color-grey-0;
    }
  }

  .-ai-button {
    // margin-top: 10px;
    &:not(:disabled) {
      cursor: pointer;
    }
  }
}

.-ai-separator {
  margin: 10px 0;
  text-align: center;
  color: $color-grey-0;
  font-style: italic;
}
// Custom styling for AI tooltip
.tm-empty-view-ai-btn-container {
  position: relative;
}
.tooltip.wt-preset-tooltip.-ai-tooltip {
  z-index: 0;

  .tooltip-inner {
    font-size: 13px;
    padding: 10px 12px;
    max-width: 500px;
  }
}
</style>
